import { Alert } from "@mantine/core";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { AlertPresets } from "../../../../mantine/mantinePresets";
import { MarkdownLink } from "../../../ReactMarkdown/MarkdownLink";
import { RegulatoryDutyDetailRow } from "../../../RegulatoryDuties/RegulatoryDutyList/RegulatoryDutyItem/RegulatoryDutyDetailRow/RegulatoryDutyDetailRow";
import { type RegulatoryDutyType } from "../../hooks/useRegulatoryDuties";
import type { DocumentsWidgetProps } from "../DocumentsWidget/DocumentsWidget";
import { DocumentsWidget } from "../DocumentsWidget/DocumentsWidget";
import "./OverviewTab.scss";

const warningTexts = ["Qualitätsverbesserung", "Wartungshinweis"] as const;
const slugsWithRevoke = [
  "rueckerstattung-finanzielle-beteiligung-nach-paragraph-6-eeg"
];

interface OverviewTabProps extends Omit<
  DocumentsWidgetProps,
  "isRevokeable" | "handleErrorMessage"
> {
  regulatoryDuty: RegulatoryDutyType | null;
}

function OverviewTab({
  regulatoryDuty,
  ...documentsTabProps
}: OverviewTabProps) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const handleErrorMessage = (message: string | null) => {
    setErrorMessage(message);
  };
  const showRegulatoryDuty = regulatoryDuty !== null;
  const isRevokeable = slugsWithRevoke.includes(regulatoryDuty?.slug || "");

  const isWarning = warningTexts.some((warningText) =>
    errorMessage?.includes(warningText)
  );

  return (
    <div className="OverviewTab">
      {showRegulatoryDuty && (
        <div className="todo-property">
          <RegulatoryDutyOverview regulatoryDuty={regulatoryDuty} />
        </div>
      )}
      {errorMessage && (
        <Alert
          color={
            isWarning ? AlertPresets.warning.color : AlertPresets.error.color
          }
          icon={isWarning ? AlertPresets.warning.icon : AlertPresets.error.icon}
          mb="xs"
        >
          {errorMessage}
        </Alert>
      )}
      <DocumentsWidget
        handleErrorMessage={handleErrorMessage}
        isRevokeable={isRevokeable}
        {...documentsTabProps}
      />
    </div>
  );
}

interface RegulatoryDutyOverviewProps {
  regulatoryDuty: RegulatoryDutyType;
}

function RegulatoryDutyOverview({
  regulatoryDuty
}: RegulatoryDutyOverviewProps) {
  return (
    <div className="regulatory-duty-rows">
      <RegulatoryDutyDetailRow title="Empfänger">
        {regulatoryDuty.obligee}
      </RegulatoryDutyDetailRow>
      <RegulatoryDutyDetailRow title="Erfüllungsprozess">
        {regulatoryDuty.fulfillmentProcess && (
          <ReactMarkdown
            components={{
              a: MarkdownLink
            }}
          >
            {regulatoryDuty.fulfillmentProcess}
          </ReactMarkdown>
        )}
      </RegulatoryDutyDetailRow>
    </div>
  );
}

export { OverviewTab, OverviewTabProps };
